module.exports = __webpack_public_path__ + "static/media/RenaultLifeWeb-Bold.01198433.eot";


//////////////////
// WEBPACK FOOTER
// ./src/styles/fonts/renault-life/RenaultLifeWeb-Bold.eot
// module id = 928
// module chunks = 0